import { render, staticRenderFns } from "./TextareaPage.vue?vue&type=template&id=01647593&"
import script from "./TextareaPage.vue?vue&type=script&lang=js&"
export * from "./TextareaPage.vue?vue&type=script&lang=js&"
import style0 from "./TextareaPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports